import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-637f0a32"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "five-point-wrapper paddingTop40" }
const _hoisted_2 = { class: "five-point" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-center" }, "产品亮点", -1))
const _hoisted_4 = { class: "row-flex items-start justify-center" }
const _hoisted_5 = ["src"]
const _hoisted_6 = ["onClick", "onMouseenter"]
const _hoisted_7 = { class: "name paddingBot8" }
const _hoisted_8 = { class: "content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("img", {
          src: _ctx.fivePointData[_ctx.selectIndex].showImg,
          class: "marginRight24"
        }, null, 8, _hoisted_5),
        _createElementVNode("div", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fivePointData, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.name,
              class: _normalizeClass({
            'example-point': true,
            relative: true,
            'is-active': _ctx.selectIndex === index,
          }),
              onClick: ($event: any) => (_ctx.selectIndex = index),
              onMouseenter: ($event: any) => (_ctx.selectIndex = index)
            }, [
              _createElementVNode("span", _hoisted_7, _toDisplayString(item.name), 1),
              _createElementVNode("span", _hoisted_8, _toDisplayString(item.content), 1),
              _createElementVNode("span", {
                class: _normalizeClass(['triangle', 'absolute', 'triangle-' + (index + 1)])
              }, null, 2)
            ], 42, _hoisted_6))
          }), 128))
        ])
      ])
    ])
  ]))
}